export default __webpack_public_path__ + "ad77cc14a9ec00043e1880636c018881.png";